import AddHardwareModal from "./add.hardware.modal";

export default AddHardwareModal;
